import { z } from 'zod';

export const supplierSchema = z.object({
  name: z.string().min(1, 'Name is required'),
  code: z.string().max(3, 'Code must be at most 3 characters').optional(),
  contactName: z.string().optional(),
  email: z.string().email().optional().or(z.literal('')),
  phone: z.string().optional(),
  status: z.enum(['Active', 'Inactive']),
  internalNotes: z.string().optional(),
});

export type SupplierFormData = z.infer<typeof supplierSchema>;

export interface Supplier extends SupplierFormData {
  id: string;
  createdAt: string;
  updatedAt: string;
}
